import KeenSlider from 'keen-slider';

class ThumbnailSlider {
  constructor(sliderEl, prevBtn, nextBtn) {
    this.sliderEl = sliderEl;
    this.prevBtn = prevBtn;
    this.nextBtn = nextBtn;

    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);

    if (this.sliderEl.childElementCount > 5) {
      this.init();
    } else {
      this.destroy();
    }
  }

  init() {
    this.sliderEl.classList.remove('space-x-3');
    Array.from(this.sliderEl.children).forEach((child) => child.classList.remove('w-1/5'));

    // eslint-disable-next-line no-new
    new KeenSlider(this.sliderEl, {
      loop: true,
      slidesPerView: 4,
      spacing: 20,
      breakpoints: {
        '(min-width: 1280px)': {
          slidesPerView: 6,
        },
      },
      created: (instance) => {
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => instance.prev());
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => instance.next());
        }
      },
    });
  }

  destroy() {
    this.sliderEl.classList.remove('keen-slider');
    Array.from(this.sliderEl.children).forEach((child) => child.classList.remove('keen-slider__slide'));

    if (this.prevBtn) {
      this.prevBtn.classList.add('hidden');
    }

    if (this.nextBtn) {
      this.nextBtn.classList.add('hidden');
    }
  }
}

export default ThumbnailSlider;
